"use client";

import ContactInfo from "../../components/contact-info";
import { useWizard } from "../../context";

type Props = {
  [k: string]: never;
};

export default function StepFour({}: Props) {
  const { actions } = useWizard();

  actions.goBackCheck(4);

  return <ContactInfo />;
}
